import { WSPage, WSPageToolbar } from "@wingspanhq/fe-component-library";
import React from "react";
import { FilterableTableStatements } from "../components/TableStatements/FilterableTableStatements";

export const RouteStatements: React.FC = () => (
  <WSPage>
    <WSPageToolbar title="Statements" />
    <FilterableTableStatements />
  </WSPage>
);
